import styled from 'styled-components';

const FieldHeader = styled.div`
  font-size: 1.25em;
  margin: 5px 0;
  padding: 0;
  font-weight: 500;
  line-height: 1.2em;
`;

export default FieldHeader;



// WEBPACK FOOTER //
// ./app/containers/FastCover/components/FieldHeader/index.js